import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import DashboardHome from '../components/DashboardHome.vue'
import BookList from '../components/BookList.vue'
import BookDetail from '../views/BookDetail.vue';
import ExecutionDetail from '../views/ExecutionDetail.vue';

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/dashboard',
    component: Dashboard,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'DashboardHome',
        component: DashboardHome
      },
      {
        path: 'books',
        name: 'BookList',
        component: BookList
      },
      {
        path: 'book/:id',
        name: 'BookDetail',
        component: BookDetail,
        props: true
      },
      {
        path: 'book/:bookId/execution/:executionId',
        name: 'ExecutionDetail',
        component: ExecutionDetail,
        props: true
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  // Cerca sia access_token che refresh_token per la sessione
  const loggedIn = localStorage.getItem('access_token') && localStorage.getItem('refresh_token');

  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next('/');
  } else if (to.path === '/' && loggedIn) {
    // Se l'utente è già loggato, va direttamente in dashboard
    next('/dashboard');
  } else {
    next();
  }
})

export default router
